import { useState } from "react";

function CheckoutPage({ cart, totalPrice }) {
  const [customer, setCustomer] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
  });

  const [error, setError] = useState("");
  const [comingSoonMessage, setComingSoonMessage] = useState("");
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);

  function handleChange(e) {
    const { name, value } = e.target;

    setCustomer({
      ...customer,
      [name]: value,
    });

    setError("");
  }

  function handlePhoneChange(e) {
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);

    setCustomer({
      ...customer,
      phone: value,
    });

    setError("");
  }

  function handlePlaceOrder() {
    if (isPlacingOrder) return;

    setIsPlacingOrder(true);
    setError("");
    setComingSoonMessage("Online ordering will be available soon. Stay tuned!");
  }

  return (
    <div
      style={{
        padding: "40px 30px",
        background: "#f7f8fa",
        minHeight: "100vh",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
        <h1
          style={{
            marginBottom: "30px",
            color: "#111827",
          }}
        >
          Checkout
        </h1>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1.2fr 0.8fr",
            gap: "30px",
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "18px",
              padding: "25px",
              boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
            }}
          >
            <h2 style={{ marginTop: 0, marginBottom: "20px" }}>
              Customer Details
            </h2>

            <div style={{ display: "grid", gap: "15px" }}>
              <input
                type="text"
                name="fullName"
                placeholder="Full Name"
                value={customer.fullName}
                onChange={handleChange}
                style={inputStyle}
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={customer.email}
                onChange={handleChange}
                style={inputStyle}
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={customer.phone}
                onChange={handlePhoneChange}
                style={inputStyle}
              />

              <textarea
                name="address"
                placeholder="Shipping Address"
                rows="5"
                value={customer.address}
                onChange={handleChange}
                style={{ ...inputStyle, resize: "none" }}
              ></textarea>
            </div>
          </div>

          <div
            style={{
              background: "white",
              borderRadius: "18px",
              padding: "25px",
              boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
              height: "fit-content",
            }}
          >
            <h2 style={{ marginTop: 0, marginBottom: "20px" }}>
              Order Summary
            </h2>

            {cart.length === 0 ? (
              <p style={{ color: "#6b7280" }}>Your cart is empty</p>
            ) : (
              <div>
                {cart.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "14px",
                      paddingBottom: "14px",
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    <div>
                      <p
                        style={{
                          margin: "0 0 5px 0",
                          fontWeight: "600",
                          color: "#111827",
                        }}
                      >
                        {item.name}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          color: "#6b7280",
                          fontSize: "14px",
                        }}
                      >
                        Qty: {item.quantity}
                      </p>
                    </div>

                    <p
                      style={{
                        margin: 0,
                        fontWeight: "bold",
                        color: "#111827",
                      }}
                    >
                      ₹{item.price * item.quantity}
                    </p>
                  </div>
                ))}

                <h3
                  style={{
                    marginTop: "20px",
                    color: "#111827",
                  }}
                >
                  Total: ₹{totalPrice}
                </h3>

                {error && (
                  <p
                    style={{
                      color: "#dc2626",
                      fontSize: "14px",
                      marginTop: "12px",
                      marginBottom: "0",
                      fontWeight: "bold",
                    }}
                  >
                    {error}
                  </p>
                )}

                {comingSoonMessage && (
                  <div
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #cbd5e1",
                      borderRadius: "10px",
                      padding: "12px",
                      marginTop: "12px",
                      color: "#0f172a",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    {comingSoonMessage}
                  </div>
                )}

                <button
                  onClick={handlePlaceOrder}
                  disabled={isPlacingOrder}
                  style={{
                    width: "100%",
                    background: isPlacingOrder ? "#6b7280" : "#111827",
                    color: "white",
                    border: "none",
                    padding: "14px",
                    borderRadius: "10px",
                    fontWeight: "bold",
                    cursor: isPlacingOrder ? "not-allowed" : "pointer",
                    marginTop: "15px",
                  }}
                >
                  {isPlacingOrder ? "Coming Soon" : "Place Order"}
                </button>

                <p
                  style={{
                    marginTop: "10px",
                    marginBottom: 0,
                    color: "#6b7280",
                    fontSize: "13px",
                  }}
                >
                  Online ordering is currently under development.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  borderRadius: "10px",
  border: "1px solid #d1d5db",
  outline: "none",
  fontSize: "14px",
  boxSizing: "border-box",
};

export default CheckoutPage;
